import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AppMenuitem } from './app.menuitem';
import { AuthService } from '../../services/auth.service';
import { take } from 'rxjs';
import { ConfigService } from '../../services/config.service';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [CommonModule, AppMenuitem, RouterModule],
  template: `<ul class="layout-menu">
    <ng-container *ngFor="let item of model; let i = index">
      <li
        app-menuitem
        *ngIf="!item.separator"
        [item]="item"
        [index]="i"
        [root]="true"
      ></li>
      <li
        *ngIf="item.separator"
        class="menu-separator"
      ></li>
    </ng-container>
  </ul> `
})
export class AppMenu {
  private authService = inject(AuthService);
  private configService = inject(ConfigService);
  private config: any;
  model: MenuItem[] = [];

  ngOnInit() {
    this.configService
      .getConfig()
      .pipe(take(1))
      .subscribe((cfg) => {
        this.config = cfg;
        this.model = [
          {
            label: 'Home',
            items: [{ label: 'Dashboard', icon: 'pi pi-fw pi-home', routerLink: ['/'] }]
          },
          {
            label: 'Pages',
            icon: 'pi pi-fw pi-briefcase',
            routerLink: ['/pages'],
            items: [
              {
                label: 'Company',
                icon: 'pi pi-fw pi-building',
                routerLink: ['/company'],
                visible: this.authService.isSuperAdmin()
              },
              { label: 'Patients', icon: 'pi pi-users', routerLink: ['/patient'] },
              {
                label: 'Caregiver',
                icon: 'pi pi-user',
                routerLink: ['/caregiver']
              },
              {
                label: this.config?.titles?.appointments || 'Appointments',
                icon: 'pi pi-calendar',
                routerLink: ['/appointments']
              },
              {
                label: this.config?.titles?.appointment_visit || 'Visit logs',
                icon: 'pi pi-calendar-plus',
                routerLink: ['/appointment-visits']
              },
              {
                label: 'Users',
                icon: 'pi pi-users',
                routerLink: ['/user'],
                visible: this.authService.isSuperAdmin()
              },
              {
                label: 'Insurance',
                icon: 'pi pi-shield',
                routerLink: ['/insurance'],
                visible: this.authService.isSuperAdmin()
              },
              { label: 'Invoice', icon: 'pi pi-file', routerLink: ['/invoice'] },
              {
                label: 'Finance',
                icon: 'pi pi-money-bill',
                items: [
                  {
                    label: 'Patient',
                    icon: 'pi pi-user',
                    routerLink: ['/finance/patient']
                  },
                  {
                    label: 'Caregiver',
                    icon: 'pi pi-users',
                    routerLink: ['/finance/caregiver']
                  }
                ]
              },
              {
                label: 'Billings',
                icon: 'pi pi-receipt',
                items: [
                  {
                    label: 'Payment Methods',
                    icon: 'pi pi-credit-card',
                    routerLink: ['/payment-methods']
                  },
                  {
                    label: 'Bills & Payments',
                    icon: 'pi pi-credit-card',
                    routerLink: ['/bills-and-payments']
                  },
                  {
                    label: 'Advanced Billing',
                    icon: 'pi pi-dollar',
                    routerLink: ['/advance-billing-invoice'],
                    visible: this.authService.isSuperAdmin()
                  }
                ]
              },
              {
                label: 'Data Exchange',
                icon: 'pi pi-sync',
                routerLink: ['/data-exchange']
              },
              {
                label: 'HHA Config',
                icon: 'pi pi-cog',
                routerLink: ['/hha-config'],
                visible: this.authService.isSuperAdmin()
              },
              {
                label: 'Import',
                icon: 'pi pi-file-import',
                routerLink: ['/imports']
              },
              { label: 'Tasks', icon: 'pi pi-check-square', routerLink: ['/task'] },
              {
                label: 'Report',
                icon: 'pi pi-chart-bar',
                routerLink: ['/report'],
                visible: this.authService.hasFeatureEnabled('enableManualPatientFeedback')
              },
              {
                label: 'Care Service',
                icon: 'pi pi-briefcase',
                routerLink: ['/care-service'],
                visible: this.authService.hasFeatureEnabled('enableCareService')
              },
              {
                label: 'Program',
                icon: 'pi pi-list',
                routerLink: ['/program'],
                visible: this.authService.hasFeatureEnabled('enableProgram')
              },
              {
                label: 'Support Ticket',
                icon: 'pi pi-ticket',
                routerLink: ['/support-ticket'],
                visible: this.authService.hasFeatureEnabled('enableSupportTicket')
              },
              {
                label: 'Developer',
                icon: 'pi pi-code',
                visible: this.authService.isDeveloper(),
                items: [
                  {
                    label: 'Dev Only',
                    icon: 'pi pi-tools',
                    routerLink: ['/dev-only']
                  }
                ]
              },
              { label: 'Settings', icon: 'pi pi-cog', routerLink: ['/settings'] }
            ]
          }
        ];
      });
  }
}
